module.exports = __webpack_public_path__ + "static/img/not_supported.ca5db23.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@intelipost-modules/secure-ng/dist/images/not_supported.png
// module id = cuNM
// module chunks = 72